import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

// So that we can navigate to the same route without errors
// Should we be doing this? Maybe not.
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(() => {});
};

import AuthRoutes from "../routes/auth";
import ElectionRoutes from "../routes/election";
import StaffRoutes from "../routes/staff";
import Dashboard from "../components/Dashboard";
import LiveElections from "../components/LiveElections";
import LiveElectionResults from "../components/LiveElectionResults";
import Voting from "../components/vote/Voting";
import RetrievePIN from "../components/vote/RetrievePIN";

const router = new VueRouter({
  mode: "history",
  routes: [
    ...AuthRoutes,
    ...ElectionRoutes,
    ...StaffRoutes,
    {
      path: "/dashboard",
      name: "dashboard",
      component: Dashboard,
      meta: {
        requiresVisitor: true,
        description: "Election dashboard - stats, perf and indexes",
      },
    },
    {
      path: "/",
      name: "live",
      component: LiveElections,
      meta: {
        requiresVisitor: true,
        description: "Live elections",
      },
    },
    {
      path: "/results",
      name: "results",
      component: LiveElectionResults,
      meta: {
        requiresAuth: true,
        description: "Live election results",
      },
    },
    {
      props: true,
      path: "/vote/:uuid",
      name: "vote",
      component: Voting,
      meta: {
        requiresVisitor: true,
        description: "Cast vote",
      },
    },
    {
      props: true,
      path: "/retrieve/:uuid",
      name: "retrieve",
      component: RetrievePIN,
      meta: {
        requiresVisitor: true,
        description: "Retrieve voting PIN",
      },
    },
    {
      path: "*",
      redirect: "/",
    },
  ],
});

export default router;
